var reservhotel = {
  heroEyebrow: "Motor de reservas",
  heroTitle: "Marival Resorts para Agentes de Viajes",
  heroText: "Es un placer darle la bienvenida a una plataforma en la que los Asesores de Viajes podrán acceder y reservar las vacaciones de sus clientes directamente en el motor de reservas de Marival Resorts.",
  heroButton: "Abrir Reserv Hotel",
  quickLinksTitle: "Accesos rápidos",
  quickLinks: [
    {
      title: "Media Kit",
      description: "Fotos, videos y FactSheets",
    },
    {
      title: "Bodas",
      description: "Paquetes y catálogos de bodas",
    },
    {
      title: "Contacto",
      description: "",
    },
  ],
  resortsTitle: "Resorts disponibles",
  photoPlaceholder: "[ Foto del resort ]",
  resorts: [
    {
      title: "Armony Marival Resort & Spa Punta de Mita - MGallery Collection",
      location: "Punta de Mita · Todo Incluido",
    },
    {
      title: "Marival Distinct All-Suites & World Spa - Handwritten Collection",
      location: "Nuevo Vallarta · Todo Incluido",
    },
    {
      title: "Marival Emotions Resort & Suites Riviera Nayarit by Mercure",
      location: "Nuevo Vallarta · Todo Incluido",
    },
  ],
};

module.exports = reservhotel;
